import { useState, useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import { Input } from '../../components/Input/Input'
import { Button } from '../../components/Button/Button'
import { FcGoogle } from 'react-icons/fc'
import { AiOutlineEye, AiOutlineEyeInvisible } from 'react-icons/ai'
import { generateGoogleAuthUrl } from '../../config/oauthConfig'
import './Login.css'

export default function LoginPage() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const { login } = useContext(AuthContext)
  const navigate = useNavigate()

  const handleLogin = async () => {
    setError('')
    setLoading(true)

    try {
      const apiBase = process.env.REACT_APP_API_BASE || 'http://localhost:8005'
      const response = await fetch(`${apiBase}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      })

      const data = await response.json()
      if (!response.ok) throw new Error('ログインに失敗しました')

      login(
        data.access_token,
        data.role,
        data.user_name,
        data.refresh_token,
        data.user_id
      )
      navigate('/home/schedule')
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  const handleGoogleLogin = () => {
    try {
      const authUrl = generateGoogleAuthUrl()
      window.location.href = authUrl
    } catch (err) {
      setError('Failed to initiate Google login: ' + err.message)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin()
  }

  const [showLogo, setShowLogo] = useState(true)

  useEffect(() => {
    const handleScroll = () => {
      setShowLogo(window.scrollY < 100)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div className='min-h-screen bg-gray-100 flex items-center justify-center w-full p-6'>
      <div className='w-96 text-gray-900 p-6 rounded-xl'>
        <div className='text-center mb-6'>
          <h1 className='text-3xl font-normal text-gray-900 mb-2'>ログイン</h1>
        </div>

        <div className='space-y-6'>
          {error && <p className='text-red-500 text-sm text-center'>{error}</p>}

          <div>
            <Input
              className='w-full px-4 border border-gray-300 bg-white text-gray-900 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none'
              type='email'
              placeholder='メールアドレスまたは電話番号'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={handleKeyDown}
              autoFocus
            />
          </div>

          <div className='relative'>
            <Input
              className='w-full px-4 pr-10 border border-gray-300 bg-white text-gray-900 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-500 outline-none'
              type={showPassword ? 'text' : 'password'}
              placeholder='パスワードを入力してください'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
            />
            <button
              type='button'
              className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700'
              onClick={() => setShowPassword((v) => !v)}
            >
              {showPassword ? (
                <AiOutlineEyeInvisible size={20} />
              ) : (
                <AiOutlineEye size={20} />
              )}
            </button>
          </div>

          <Button
            className='w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-lg font-medium'
            onClick={handleLogin}
            disabled={loading}
          >
            {loading ? 'サインイン中...' : 'ログイン'}
          </Button>

          <Button
            className='w-full flex items-center justify-center gap-2 border border-gray-300 py-3 rounded-lg bg-white hover:bg-gray-50 transition'
            onClick={handleGoogleLogin}
            disabled={loading}
          >
            <FcGoogle size={20} />
            <span className='font-medium text-gray-700'>Googleでログイン</span>
          </Button>
        </div>
      </div>
    </div>
  )
}
